import { privateToPublic, privateToAddress, toBuffer, isValidPrivate, toChecksumAddress } from 'ethereumjs-util';

/**
 * The Key-class of the wallet
 */
export class Key {
    private readonly _privateKey: Buffer;
    private readonly _publicKey: string;
    private readonly _address: string;

    /**
     * initialized a new key
     * @param privateKey the privateKey of the key
     */
    constructor(privateKey: string | Buffer) {
        if (!isValidPrivate(Buffer.isBuffer(privateKey) ? privateKey : toBuffer(privateKey))) {
            throw new Error('Invalid private key');
        }

        this._privateKey = Buffer.isBuffer(privateKey) ? privateKey : toBuffer(privateKey);
        this._publicKey = privateToPublic(this._privateKey).toString('hex');
        this._address = privateToAddress(this._privateKey).toString('hex');
    }

    get privateKey(): string {
        return '0x' + this._privateKey.toString('hex');
    }

    get address(): string {
        return toChecksumAddress(`0x${this._address}`);
    }

    get publicKey(): string {
        return '0x' + this._publicKey;
    }
}
